import React from "react";

import { Sidebar as SidebarTelluriaUi } from "@npm-telluria-tecnologia/telluria-ui";

import SidebarMenus from "@molecules/SidebarMenus";

import useTheme from "@styles/useTheme";

const Sidebar: React.FC = () => {

  const { theme } = useTheme();

  return (
    <SidebarTelluriaUi
      primaryColor={theme.brand.navy}
    >
      <SidebarMenus />
    </SidebarTelluriaUi>
  );
};

export default Sidebar;
